<template>
  <div class="row mb-5">
    <el-table
      class="table-responsive align-items-center table-flush"
      header-row-class-name="thead-light"
      :data="salesInvoice.items"
    >
      <el-table-column :label="$t('COMMON.CODE')" prop="code">
        <template v-slot="{ row }">
          <div v-if="row.salesInvoiceable">
            <a
              href="#"
              @click.prevent="goToSalesInvoiceable(row.salesInvoiceable)"
            >
              {{ row.code }}<br />
              <div
                class="text-muted sales-invoice-item-excerpt"
                v-html="row.excerpt"
              ></div>
            </a>
          </div>
          <div v-if="!row.salesInvoiceable">
            {{ row.code }}<br />
            <div
              class="text-muted sales-invoice-item-excerpt"
              v-html="row.excerpt"
            ></div>
          </div>
        </template>
      </el-table-column>

      <el-table-column
        :label="$t('COMMON.UNIT_PRICE')"
        prop="unit_price"
        class-name="number-column"
        label-class-name="number-column"
      >
        <template v-slot="{ row }">
          {{ $formatCurrency(row.unit_price) }}
        </template>
      </el-table-column>

      <el-table-column
        :label="$t('COMMON.QUANTITY')"
        prop="quantity"
        class-name="number-column"
        label-class-name="number-column"
      />

      <el-table-column
        :label="$t('COMMON.FORMAT')"
        class-name="number-column"
        label-class-name="number-column"
      >
        <template v-slot="{ row }">
          <object-link :object="row.unitOfMeasureUnit" />
        </template>
      </el-table-column>
      
      <el-table-column
        :label="$t('COMMON.SUBTOTAL')"
        class-name="number-column"
        label-class-name="number-column"
      >
        <template v-slot="{ row }">
          {{ $formatCurrency(row.pricing.subtotal) }}
          <!--
            Container deposit shown as a secondary figure: el-table renders one
            row per document line and the deposit is a component of the line, not
            a line of its own. On the printed invoice it does get its own line.
          -->
          <div v-if="row.deposit_total_amount > 0" class="text-muted small">
            + {{ $t("COMMON.DEPOSIT") }}
            {{ $formatCurrency(row.deposit_total_amount) }}
          </div>
        </template>
      </el-table-column>

      <el-table-column
        :label="$t('COMMON.DISCOUNT')"
        class-name="number-column"
        label-class-name="number-column"
      >
        <template v-slot="{ row }">
          {{ $formatCurrency(row.pricing.discount_amount) }}
          <span class="text-muted">({{ row.discount }}%)</span>
        </template>
      </el-table-column>

      <el-table-column
        :label="$t('COMMON.TAXES')"
        class-name="text-center"
        label-class-name="text-center"
      >
        <template v-slot="{ row }">
          <span
            v-for="tax in getItemTaxLabels(row)"
            :key="tax"
            class="badge badge-secondary mr-1"
          >
            {{ tax }}
          </span>
        </template>
      </el-table-column>

      <el-table-column
        min-width="50px"
        align="center"
        v-if="salesInvoice.status === INVOICE_STATUS_DRAFT"
      >
        <div slot-scope="{ row }" class="table-actions">
          <el-tooltip :content="$t('COMMON.EDIT')" placement="top">
            <a
              type="text"
              @click="openSalesInvoiceItemModal(row)"
              class="table-action"
              data-toggle="tooltip"
              style="cursor: pointer"
            >
              <i class="fas fa-edit"></i>
            </a>
          </el-tooltip>
        </div>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip,
  Select,
  Option,
  Button,
} from "element-ui";
import formMixin from "@/mixins/form-mixin";
import taxDisplayMixin from "@/mixins/tax-display-mixin";
import { INVOICE_STATUS_DRAFT } from "@/constants/invoices";

export default {
  name: "sales-invoice-view-details-sales-invoice-item-table",

  components: {
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
  },

  mixins: [formMixin, taxDisplayMixin],

  props: ["salesInvoice"],

  data() {
    return {
      INVOICE_STATUS_DRAFT: INVOICE_STATUS_DRAFT,
    };
  },

  computed: {},

  methods: {
    openSalesInvoiceItemModal(salesInvoiceItem) {
      this.$emit("onOpenSalesInvoiceItemModal", salesInvoiceItem);
    },

    async goToSalesInvoiceable(salesInvoiceable) {
      this.$router.push(this.$objectViewRoute(salesInvoiceable));
    },

    getItemTaxLabels(row) {
      return this.getInvoiceItemTaxLabels(row);
    },
  },

  mounted() {},

  watch: {},
};
</script>

<style>
.sales-invoice-item-excerpt p,
.sales-invoice-item-excerpt,
.sales-invoice-item-excerpt * {
  font-size: 0.7rem;
}
</style>
